/* Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { NvHigCellComparison } from '../../models/hig-modal-shared.types';

@Component({
    selector: 'nv-hig-cell-comparison',
    templateUrl: './nv-hig-cell_comparison.component.html',
    styleUrls: ['./nv-hig-cell_comparison.component.scss'],
    imports: [TranslateModule]
})
export class NvHigCellComparisonComponent {
    @Input() data: NvHigCellComparison[] = [];
}
